import React from 'react'
import { connect } from 'react-redux';
import { Modal, FormGroup, FormControl } from 'react-bootstrap'
import Multiselect from 'react-widgets/lib/Multiselect';
import reject from 'lodash/reject'
import find from 'lodash/find'
import * as commonActions from '../../actions/commonActions';

class ModalAutoDrop extends React.Component {
  state = {
    selected: [],
    confirmValue: '',
    disabled: true
  }

  componentDidUpdate(prevProps) {
    if (prevProps.position === null && this.props.position !== null) {
      this.updateSelectedState()
    }
  }

  updateSelectedState() {
    const selected = find(this.props.waitlist.data, { id: this.props.position.id })
      .conditional_drops.map(item =>
        find(this.props.assignments, { id: item.assignment })
      )
      .map(item => {
        const course = find(this.props.assignmentCourses, {id: item.course})

        return {
          id: course.id,
          slug: course.slug
        }
      })

    this.setState({
      selected
    })
  }

  handleChange = (value) => {
    this.setState({
      selected: value
    })
  }

  handleConfirmChange = ({target: { value }}) => {
    this.setState({
      confirmValue: value,
      disabled: value !== 'SET'
    })
  }

  handleSubmit = event => {
    event.preventDefault()
    this.props.onSubmit(this.state.selected).then(this.handleClose)
  }

  handleClose = () => {
    this.setState({
      confirmValue: '',
      disabled: true
    })

    this.props.onClose()
  }

  render() {
    const {
      disabled,
      confirmValue,
      selected
    } = this.state
    const { position, assignmentCourses } = this.props
    const allAssignmentCourses = assignmentCourses.map(item => {
      return {
        slug: item.slug,
        id: item.id
      }
    })
    let multiselectAutoDropData = []
    if (position) {
      multiselectAutoDropData =
        reject(allAssignmentCourses, item => {
          return item.id === find(this.props.waitlist.data, item => item.id === position.id).course
        }).map(c => {
          const course = this.props.courses.find(x => x.id === c.id)
          const name = course ? course.longname : '(No Name)'
          return {
            ...c,
            msText: `${c.slug} - ${(name.length ? name : '(No Name)').slice(0, 22)}${(name.length ? name : '(No Name)').length > 25 ? '...' : ''}`
          }
        })
    }

    return (
      <Modal show={!!position} onHide={this.handleClose} className="modal-waitlist-add-autodrop">
        <Modal.Header closeButton>
          <h3 className="modal-title">
            Automatic drop for {position && position.course.longname} ({position && position.course.slug})
          </h3>
        </Modal.Header>
        <form onSubmit={this.handleSubmit}>
          <Modal.Body>
            <p>
            You will be automatically dropped from these classes if your waitlist request is successful. A conditional drop may be needed to avoid issues like conflicts or credit limits.
            </p>
            <Multiselect
              data={multiselectAutoDropData}
              value={selected}
              textField="msText"
              valueField="id"
              onChange={this.handleChange}
            />
            <p className="mt-2">
              Type <span className="textColorPurple">SET</span> to confirm.
            </p>
            <FormGroup controlId="formControlsConfirmAutoDropInputValue">
              <FormControl
                componentClass="input"
                value={confirmValue}
                onChange={this.handleConfirmChange}
              />
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <div className="buttonsSpaceBetween">
              <button className="btn btn-ter" type="button" onClick={this.handleClose}>
                Cancel
              </button>
              <button className="btn btn-primary" type="submit" disabled={disabled}>
                Set
              </button>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

function mapStateToProps (state) {
  return {
    courses: state.courses,
    waitlist: state.waitlist,
    assignments: state.assignments,
    assignmentCourses: state.student.assignments
      ? commonActions.getCoursesObjsByIds(state.student.assignments.map(item => item.course), state.courses)
      : []
  }
}

export default connect(mapStateToProps)(ModalAutoDrop)



// WEBPACK FOOTER //
// ./src/components/rank/ModalAutoDrop.js